import { useState } from "react";
import { ErrorBoundary } from "../../components/ui/ErrorBoundary";
import { UiPortalsProvider } from "../../components/ui/UiPortal";
import {
  FeatureToggleProvider,
  configFeatureProvider,
  isFeatureEnabledFactory,
  locationSearchFeatureProvider
} from "../../components/ui/featureToggle";
import { ProgressIndicator } from "../../components/widgets/ProgressIndicator/ProgressIndicator_view";
import { AgGridContextProvider } from "../../contexts/agGrids/AgGridContext";
import { OrganisationSettingsContextProvider } from "../../contexts/organisationSettings/OrganisationSettingsContext";
import PermissionContext, { PermissionContextProvider } from "../../contexts/permissions/PermissionsContext";
import { ClaimsContextProvider } from "../../core/auth/authorise";
import { UserProvider } from "../../core/auth_insight/UserContext";
import { HasOrganisationAccess } from "../../core/router/Route";
import { FlightPathThemeProvider } from "../../core/theme/themeProvider";
import { ToasterServiceView } from "../../core/toaster/ToasterService";
import {
  OrganisationContextModel,
  OrganisationContextProvider
} from "../../services/local/organisationContext/OrganisationContextModel";
import { SignEulaService } from "../../services/local/signEulaService/SignEulaService";
import { ShellRoutes } from "../_shell/routes";

const isFeatureEnabled = isFeatureEnabledFactory(
  configFeatureProvider(window.appConfig),
  locationSearchFeatureProvider
);
export const InsightProviders: React.FC<ReactProps> = () => {
  const [organisationContext] = useState(() => new OrganisationContextModel());
  return (
    <FlightPathThemeProvider>
      <ToasterServiceView />
      <ProgressIndicator />
      <FeatureToggleProvider isFeatureEnabled={isFeatureEnabled}>
        <UiPortalsProvider>
          <ErrorBoundary>
            <UserProvider>
              <PermissionContextProvider permissionContext={PermissionContext}>
                <OrganisationSettingsContextProvider>
                  <HasOrganisationAccess>
                    <AgGridContextProvider>
                      <ClaimsContextProvider>
                        <SignEulaService>
                          <OrganisationContextProvider model={organisationContext}>
                            <ShellRoutes />
                          </OrganisationContextProvider>
                        </SignEulaService>
                      </ClaimsContextProvider>
                    </AgGridContextProvider>
                  </HasOrganisationAccess>
                </OrganisationSettingsContextProvider>
              </PermissionContextProvider>
            </UserProvider>
          </ErrorBoundary>
        </UiPortalsProvider>
      </FeatureToggleProvider>
    </FlightPathThemeProvider>
  );
};
